module.exports = __webpack_public_path__ + "img/zepto.6a18dd97.svg";